import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'

const useDeleteMission = () =>
  useMutation<void, Error, number>({
    mutationFn: MainApi.deleteMission,
  })

export default useDeleteMission
